import { ProjectStatus } from '@belimo-retrofit-portal/logic';
import { createSelector } from 'reselect';
import { getProjectViewData } from 'src/modules/project-view/selectors/getProjectViewData';

export const getProjectClosed = createSelector([
  getProjectViewData,
], (data) => data.project.data.status !== ProjectStatus.ACTIVE);
